import { withDefaultFiltersReducer } from 'app/area/shared/default-filters/reducers';
import {
  clearValidationForAllParameters, clearValidationForKeys, clearValidationForSingleParameter
} from 'app/area/shared/report/form/validation';
import { Reducer, Action } from 'redux';
import {
  ACTION, ReceiveLanguageOptions,
  RequestCompanyReport, ReceiveCompanyReport, FailCompanyReport,
  RequestDeleteCompanyReport, ReceiveDeleteCompanyReport, FailDeleteCompanyReport,
  RequestSaveCompanyReport, ReceiveSaveCompanyReport, FailSaveCompanyReport,
  UpdateTextDescription, UpdateItem, ChangeLanguage, CopyLanguageToAll,
  RequestTemplate, ReceiveTemplate, FailTemplate,
  UpdateTextItem, UpdateTextItemDescription, RemoveText, RemoveAllTexts, AddText,
  ResetTextValidation, ResetAllTextsValidation, UpdateTextsValidation,
  UpdateMetadataItem, RemoveMetadata, RemoveAllMetadata, AddMetadata, UpdateMetadataValidation,
  ResetMetadataValidation, ResetAllMetadataValidation, ClearForm, UpdateValidation, ResetValidation, ResetTextsValidation
} from './action-types';
import { languageValidationParameter } from './constants';
import { CompanyReportAdminFormState, CompanyReportItem, CompanyReportItemValidation } from './types-store';
import { CompanyReportForm } from './constants';
import { withSavedReportsReducer } from 'app/area/shared/saved-reports/reducers';
import { createId, createInitialMetadata, createInitialText } from 'app/area/company-reports-administration/form/utils/helpers';

export const INITIAL_STATE: CompanyReportAdminFormState = {
  companyReportItem: undefined,
  originalCompanyReportItem: undefined,
  newCompanyReportId: undefined,
  fetching: false,
  fetchingTemplate: false,
  deleting: false,
  saving: false,
  languageOptions: [],
  validation: {},

  typeId: undefined,
  accessType: undefined,
  displayDisabled: false,
  savedReports: undefined,
  originalSavedReports: undefined,
  currentSavedReportId: undefined,
  currentSavedReport: undefined,
  currentSavedReportOnlyIdMode: false,
  currentValidation: undefined,
  fetchingCurrentEvaluation: false,
  fetchingAddSavedReports: false,
  savedReportsValidation: {},

  fetchingFilterMetadata: [],
  filterMetadata: {},
  filterValidation: {},
  filters: undefined,
  originalFilters: undefined,

  textsValidation: {},
  metadataValidation: {}
};

const reducers: { [indexer: string]: Reducer<CompanyReportAdminFormState, Action> } = {

  [ACTION.RECEIVE_LANGUAGE_OPTIONS]: (state: CompanyReportAdminFormState,
    action: ReceiveLanguageOptions): CompanyReportAdminFormState => {

    return {
      ...state,
      languageOptions: action.options
    };
  },

  [ACTION.REQUEST_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: RequestCompanyReport): CompanyReportAdminFormState => {

    return {
      ...state,
      companyReportItem: undefined,
      originalCompanyReportItem: undefined,
      typeId: action.id,
      newCompanyReportId: undefined,

      filters: undefined,
      originalFilters: undefined,

      fetching: true,
      saving: false,
      validation: {}
    };
  },

  [ACTION.RECEIVE_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: ReceiveCompanyReport): CompanyReportAdminFormState => {

    const filterMetadata = action.filterMetadata
      .reduce((prev, filter) => ({
        ...prev,
        [filter.domain.value]: filter
      }), state.filterMetadata);

    return state.typeId === action.id
      ? {
        ...state,
        companyReportItem: action.item,
        originalCompanyReportItem: action.item,

        savedReports: action.savedReports,
        originalSavedReports: action.savedReports,
        filters: action.filters,
        originalFilters: action.filters,
        filterMetadata,

        fetching: false
      }
      : state;
  },

  [ACTION.FAIL_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: FailCompanyReport): CompanyReportAdminFormState => {

    return state.typeId === action.id
      ? {
        ...state,
        fetching: false
      }
      : state;
  },

  [ACTION.REQUEST_DELETE_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: RequestDeleteCompanyReport): CompanyReportAdminFormState => {

    return state.typeId === action.id
      ? {
        ...state,
        deleting: true
      }
      : state;
  },

  [ACTION.RECEIVE_DELETE_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: ReceiveDeleteCompanyReport): CompanyReportAdminFormState => {

    return state.typeId === action.id
      ? {
        ...state,
        deleting: false
      }
      : state;
  },

  [ACTION.FAIL_DELETE_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: FailDeleteCompanyReport): CompanyReportAdminFormState => {

    return state.typeId === action.id
      ? {
        ...state,
        deleting: false
      }
      : state;
  },

  [ACTION.REQUEST_SAVE_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: RequestSaveCompanyReport): CompanyReportAdminFormState => {

    return {
      ...state,
      typeId: action.id,
      saving: true
    };
  },

  [ACTION.RECEIVE_SAVE_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: ReceiveSaveCompanyReport): CompanyReportAdminFormState => {

    return state.typeId === action.id
      ? {
        ...state,
        newCompanyReportId: action.newCompanyReportId,
        originalCompanyReportItem: state.companyReportItem,
        originalSavedReports: state.savedReports,
        saving: false
      }
      : state;
  },

  [ACTION.FAIL_SAVE_COMPANY_REPORT]: (state: CompanyReportAdminFormState,
    action: FailSaveCompanyReport): CompanyReportAdminFormState => {

    return state.typeId === action.id
      ? {
        ...state,
        saving: false
      }
      : state;
  },

  [ACTION.CHANGE_LANGUAGE]: (state: CompanyReportAdminFormState,
    action: ChangeLanguage): CompanyReportAdminFormState => {

    const companyReportItem = state.companyReportItem || {} as CompanyReportItem;
    const language = companyReportItem.language || [];

    return {
      ...state,
      companyReportItem: {
        ...companyReportItem,
        language: language.some(languageItem => languageItem.value === action.languageId)
          ? language.map(
            languageItem => languageItem.value === action.languageId
              ? {
                ...languageItem,
                description: action.description
              }
              : languageItem
          )
          : [
            ...language,
            {
              value: action.languageId,
              description: action.description
            }
          ]
      },
      validation: clearValidationForSingleParameter(state.validation, 'language', languageValidationParameter, action.languageId)
    };
  },

  [ACTION.COPY_LANGUAGE_TO_ALL]: (state: CompanyReportAdminFormState,
    action: CopyLanguageToAll): CompanyReportAdminFormState => {

    const companyReportItem = state.companyReportItem || {} as CompanyReportItem;
    const language = companyReportItem.language || [];
    const targetLanguage = language.find(languageItem => languageItem.value === action.languageId);

    if (targetLanguage === undefined) {
      return state;
    }

    const updatedLanguage = language.map(
      languageItem => ({
        ...languageItem,
        description: targetLanguage.description
      })
    );
    const newLanguage = (state.languageOptions || [])
      .map(option => option.value)
      .filter(languageId => !language.some(languageItem => languageItem.value === languageId))
      .map(languageId => ({
        value: languageId,
        description: targetLanguage.description
      }));

    return {
      ...state,
      companyReportItem: {
        ...companyReportItem,
        language: [
          ...updatedLanguage,
          ...newLanguage
        ]
      },
      validation: clearValidationForAllParameters(state.validation, 'language', languageValidationParameter)
    };
  },

  [ACTION.UPDATE_TEXT_DESCRIPTION]: (state: CompanyReportAdminFormState,
    action: UpdateTextDescription): CompanyReportAdminFormState => {

    return {
      ...state,
      companyReportItem: {
        ...state.companyReportItem,
        textDescription: action.description
      }
    };
  },

  [ACTION.UPDATE_ITEM]: (state: CompanyReportAdminFormState,
    action: UpdateItem): CompanyReportAdminFormState => {

    const companyReportItem = {
      ...(state.companyReportItem || {}),
      ...action.item
    } as CompanyReportItem;
    const validation = clearValidationForKeys(state.validation, Object.keys(action.item) as (keyof CompanyReportItemValidation)[]);

    return {
      ...state,
      companyReportItem,
      validation
    };
  },

  [ACTION.REQUEST_TEMPLATE]: (state: CompanyReportAdminFormState,
    action: RequestTemplate): CompanyReportAdminFormState => {

    return {
      ...state,
      fetchingTemplate: true
    };
  },

  [ACTION.RECEIVE_TEMPLATE]: (state: CompanyReportAdminFormState,
    action: ReceiveTemplate): CompanyReportAdminFormState => {

    const companyReportItem = state.companyReportItem || {} as CompanyReportItem;

    return {
      ...state,
      companyReportItem: {
        ...companyReportItem,
        template: action.item.template
      },
      fetchingTemplate: false
    };
  },

  [ACTION.FAIL_TEMPLATE]: (state: CompanyReportAdminFormState,
    action: FailTemplate): CompanyReportAdminFormState => {

    return {
      ...state,
      fetchingTemplate: false
    };
  },

  [ACTION.CLEAR_FORM]: (state: CompanyReportAdminFormState,
    action: ClearForm): CompanyReportAdminFormState => {

    return {
      ...state,
      ...INITIAL_STATE,
      languageOptions: state.languageOptions
    };
  },

  [ACTION.UPDATE_VALIDATION]: (state: CompanyReportAdminFormState,
    action: UpdateValidation): CompanyReportAdminFormState => {
    return {
      ...state,
      validation: { ...state.validation, ...action.validation }
    };
  },

  [ACTION.RESET_VALIDATION]: (state: CompanyReportAdminFormState, action: ResetValidation): CompanyReportAdminFormState => {
    return {
      ...state,
      validation: { ...state.validation, [action.key]: { messages: [] } }
    };
  },

  [ACTION.UPDATE_TEXT_ITEM]: (state: CompanyReportAdminFormState,
    action: UpdateTextItem): CompanyReportAdminFormState => {

    const companyReportItem = {
      ...(state.companyReportItem || {}),
      texts: state.companyReportItem.texts.map(text => {

        if (text.id === action.textValue.id) {
          return action.textValue;
        }

        return text;
      })
    } as CompanyReportItem;

    return {
      ...state,
      companyReportItem
    };
  },

  [ACTION.UPDATE_TEXT_ITEM_DESCRIPTION]: (state: CompanyReportAdminFormState,
    action: UpdateTextItemDescription): CompanyReportAdminFormState => {

    return {
      ...state,
      companyReportItem: {
        ...state.companyReportItem,
        texts: state.companyReportItem.texts.map(text => {

          if (text.id === action.id) {
            return {
              ...text,
              textDescription: action.description
            };
          }

          return text;
        })
      }
    };
  },

  [ACTION.REMOVE_TEXT]: (state: CompanyReportAdminFormState,
    action: RemoveText): CompanyReportAdminFormState => {

    const companyReportItem = {
      ...(state.companyReportItem || {}),
      texts: state.companyReportItem.texts.filter(text => text.id !== action.id) ?? []
    } as CompanyReportItem;

    return {
      ...state,
      companyReportItem
    };
  },

  [ACTION.REMOVE_ALL_TEXTS]: (state: CompanyReportAdminFormState,
    action: RemoveAllTexts): CompanyReportAdminFormState => {

    const companyReportItem = {
      ...(state.companyReportItem || {}),
      texts: []
    } as CompanyReportItem;

    return {
      ...state,
      companyReportItem
    };
  },

  [ACTION.ADD_TEXT]: (state: CompanyReportAdminFormState, action: AddText): CompanyReportAdminFormState => {

    const texts = state.companyReportItem.texts ?? [];
    const id = createId(texts);

    return {
      ...state,
      companyReportItem: {
        ...state.companyReportItem,
        texts: texts.concat(createInitialText(id))
      }
    };
  },

  [ACTION.UPDATE_TEXTS_VALIDATION]: (state: CompanyReportAdminFormState,
    action: UpdateTextsValidation): CompanyReportAdminFormState => {

    return {
      ...state,
      textsValidation: {
        ...state.textsValidation,
        [action.id]: action.validationProps
      }
    };
  },

  [ACTION.RESET_TEXT_VALIDATION]: (state: CompanyReportAdminFormState,
    action: ResetTextValidation): CompanyReportAdminFormState => {

    return {
      ...state,
      validation: {
        ...(state.validation ?? {}),
        text: state.validation?.text?.filter?.(validation =>
          !validation?.messages.find(message => message?.parameters?.id === action.id
            && (!!action.key ? message?.parameters.field === action.key : true)
          )
        )
      }
    };
  },

  [ACTION.RESET_TEXTS_VALIDATION]: (state: CompanyReportAdminFormState,
    action: ResetTextsValidation): CompanyReportAdminFormState => {

    if (!state.textsValidation) {
      return state;
    }

    return {
      ...state,
      textsValidation: Object.keys(state.textsValidation)
        .filter(item => item !== action.id.toString())
        .reduce((result, key) => {
          result[key] = state.textsValidation[key];
          return result;
        }, {})
    };
  },

  [ACTION.RESET_ALL_TEXTS_VALIDATION]: (state: CompanyReportAdminFormState,
    action: ResetAllTextsValidation): CompanyReportAdminFormState => {
    return {
      ...state,
      textsValidation: undefined,
      validation: {
        ...state.validation,
        text: undefined
      }
    };
  },

  [ACTION.UPDATE_METADATA_ITEM]: (state: CompanyReportAdminFormState,
    action: UpdateMetadataItem): CompanyReportAdminFormState => {

    const companyReportItem = {
      ...(state.companyReportItem || {}),
      metadata: state.companyReportItem.metadata.map(item => {

        if (item.id === action.metadataValue.id) {
          return action.metadataValue;
        }

        return item;
      })
    } as CompanyReportItem;

    return {
      ...state,
      companyReportItem
    };
  },

  [ACTION.REMOVE_METADATA]: (state: CompanyReportAdminFormState,
    action: RemoveMetadata): CompanyReportAdminFormState => {

    const companyReportItem = {
      ...(state.companyReportItem || {}),
      metadata: state.companyReportItem.metadata.filter(item => item.id !== action.id) ?? []
    } as CompanyReportItem;

    return {
      ...state,
      companyReportItem
    };
  },

  [ACTION.REMOVE_ALL_METADATA]: (state: CompanyReportAdminFormState,
    action: RemoveAllMetadata): CompanyReportAdminFormState => {

    const companyReportItem = {
      ...(state.companyReportItem || {}),
      metadata: []
    } as CompanyReportItem;

    return {
      ...state,
      companyReportItem
    };
  },

  [ACTION.ADD_METADATA]: (state: CompanyReportAdminFormState,
    action: AddMetadata): CompanyReportAdminFormState => {

    const metadata = state.companyReportItem.metadata ?? [];
    const id = createId(metadata);

    return {
      ...state,
      companyReportItem: {
        ...state.companyReportItem,
        metadata: metadata.concat(createInitialMetadata(id))
      }
    };
  },

  [ACTION.UPDATE_METADATA_VALIDATION]: (state: CompanyReportAdminFormState,
    action: UpdateMetadataValidation): CompanyReportAdminFormState => {

    return {
      ...state,
      metadataValidation: {
        ...state.metadataValidation,
        [action.id]: action.validationProps
      }
    };
  },

  [ACTION.RESET_METADATA_VALIDATION]: (state: CompanyReportAdminFormState,
    action: ResetMetadataValidation): CompanyReportAdminFormState => {

    return {
      ...state,
      validation: {
        ...state.validation,
        metadata: state.validation?.metadata?.filter(validation =>
          !validation.messages.find(message => message.parameters.id === action.id && message.parameters.field === action.key)
        )
      }
    };
  },

  [ACTION.RESET_ALL_METADATA_VALIDATION]: (state: CompanyReportAdminFormState,
    action: ResetAllMetadataValidation): CompanyReportAdminFormState => {
    return {
      ...state,
      metadataValidation: undefined
    };
  }
};

const pureReducer: Reducer<CompanyReportAdminFormState> = (
  state: CompanyReportAdminFormState = INITIAL_STATE, action: Action) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};

export const reducer = withDefaultFiltersReducer(CompanyReportForm,
  withSavedReportsReducer(CompanyReportForm, pureReducer));
